import { render, staticRenderFns } from "./ClockWorkRightsComponent.vue?vue&type=template&id=e4c16c5c&"
import script from "./ClockWorkRightsComponent.vue?vue&type=script&lang=ts&"
export * from "./ClockWorkRightsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports